import { useState } from 'react';
import { useCustom } from '@refinedev/core';
import { Card, Segmented } from 'antd';
import { Area } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { DailyCountOut } from '@/api/generated/schemas';

const PERIODS = [
  { label: '7 dni', value: 7 },
  { label: '30 dni', value: 30 },
  { label: '90 dni', value: 90 },
];

export const ReviewTrend = () => {
  const [days, setDays] = useState(30);

  const { query: submissionsQuery } = useCustom<DailyCountOut[]>({
    url: 'feedback/reviews/stats/submissions',
    method: 'get',
    config: { query: { days } },
  });

  const { query: reportsQuery } = useCustom<DailyCountOut[]>({
    url: 'feedback/reviews/stats/reports',
    method: 'get',
    config: { query: { days } },
  });

  const chartData = [
    ...(submissionsQuery.data?.data ?? []).map((d: DailyCountOut) => ({
      ...d,
      type: 'Zgłoszenia',
    })),
    ...(reportsQuery.data?.data ?? []).map((d: DailyCountOut) => ({
      ...d,
      type: 'Raporty',
    })),
  ];

  return (
    <Card
      title="Trend recenzji"
      extra={
        <Segmented
          options={PERIODS.map((p) => ({ label: p.label, value: p.value }))}
          value={days}
          onChange={(v) => setDays(v as number)}
        />
      }
      loading={submissionsQuery.isLoading || reportsQuery.isLoading}
    >
      <Area
        data={chartData}
        xField="date"
        yField="count"
        colorField="type"
        height={240}
        legend={BOTTOM_LEGEND}
      />
    </Card>
  );
};
